const DOCTOR = "DOCTOR";
const EMPLOYEE = "EMPLOYEE";
const PRACTITIONER = "PRACTITIONER";
const PATIENT = "PATIENT";
const ASSISTANT = "ASSISTANT";

export const userTypes = {
    doctor: "doctor",
    patient: "patient",
    practitioner: "practitioner",
    superadmin: "employee",
    assistant: "assistant",
    // employee: "employee"
}

export default { DOCTOR, EMPLOYEE, PRACTITIONER, PATIENT, ASSISTANT };